// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1IDmt","upload":"Small_upload__1NdMi","imageWrap":"Small_imageWrap__LW-5r","removeBtn":"Small_removeBtn__Vx8KX"};